import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import useTypedContext from "hooks/useTypedContext";
import { VENDOR_CONFIG_TYPENAME } from "constants/vendor";
import { TerraformWorkflowTool } from "types/generated";
import { getDocsUrl } from "utils/getDocsUrl";

import { StackContext } from "../Context";

const MIGRATION_GUIDE_URL = getDocsUrl(
  "/vendors/terraform/terragrunt#migrating-to-native-terragrunt-platform"
);
const NATIVE_TERRAGRUNT_URL = getDocsUrl("/vendors/terragrunt");

const StackLegacyTerragruntCallout = () => {
  const { stack } = useTypedContext(StackContext);

  const vendorConfig = stack.vendorConfig;
  const isLegacyTerragrunt =
    vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.TERRAFORM &&
    vendorConfig.workflowTool !== TerraformWorkflowTool.Custom &&
    stack.labels?.some((label) => label === "terragrunt");

  if (!isLegacyTerragrunt) {
    return null;
  }

  return (
    <Callout variant="warning">
      This stack uses the legacy Terraform + Terragrunt label, which will be removed on October 31,
      2026. Please migrate to a native Terragrunt stack.
      <FeedbackActions>
        <LinkButton size="small" variant="primary" href={MIGRATION_GUIDE_URL} target="_blank">
          View migration guide
        </LinkButton>
        <LinkButton size="small" variant="secondary" href={NATIVE_TERRAGRUNT_URL} target="_blank">
          Learn about native Terragrunt
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default StackLegacyTerragruntCallout;
